import axios from 'axios'
import store from '../../../../../store'

const fccGetDadosMixin = {
  data() {
    return {
      listaSolicitacoes: [],
      listaFases: [],
      fasesEAplicacoes: [],
      spi: '',
      idSolicitacao: '',
      idFase: '',
      idAplic: '',
      dataInicioAcesso: '',
      dataFimAcesso: '',
      idLocalConfig: 0,
      dataConfig: ''
    }
  },
  watch: {
    spi(value) {
      if (value) {
        this.listarFasesEAplicacoes()
        this.listarSolicitacoes()
        this.idSolicitacao = ''
        this.idFase = ''
        this.idAplic = ''
      }
    }
  },
  computed: {
    todosCamposPrincipaisSelecionados() {
      return this.spi && this.idAplic && this.idFase
    },
    todosCamposSelecionados() {
      return this.todosCamposPrincipaisSelecionados && this.dataInicioAcesso && this.dataFimAcesso
    },
    configuracaoDaPublicacao() {
      return {
        idLocalConfig: this.idLocalConfig,
        spi: this.spi,
        idSolicitacao: Number(this.idSolicitacao),
        idFase: this.idFase,
        idAplic: this.idAplic,
        dataInicioAcesso: this.dataInicioAcesso,
        dataFimAcesso: this.dataFimAcesso,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario,
        dataConfig: this.dataConfig
      }
    },
    listaAplicacoes() {
      return this.fasesEAplicacoes
        .filter((item) => item.idfase === this.idFase)
        .map((item) => {
          return {
            aplicacao: item.idaplic
          }
        })
    }
  },
  methods: {
    listarSolicitacoes() {
      axios
        .get(
          store.state.baseUrlPublicacao + 'Publicacao/ListarTipoSolicitacaoPublicacao/' + this.spi,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listaSolicitacoes = response.data.map((item) => {
            return {
              solicitacao: item.numero
            }
          })
        })
        .catch(this.setErrorSystem)
    },
    listarFasesEAplicacoes() {
      axios
        .get(
          store.state.baseUrlPublicacao +
            'PublicacaoCorrecaoCadastral/FiltroCorrecaoCadastral/' +
            this.spi,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.fasesEAplicacoes = response.data
          const fases = this.removeDuplicados(this.fasesEAplicacoes.map((item) => item.idfase))
          this.listaFases = fases.map((fase) => {
            return {
              fase
            }
          })
        })
        .catch(this.setErrorSystem)
    },
    removeDuplicados(array) {
      const set = new Set(array)
      return Array.from(set)
    },
    limparCampos() {
      this.spi = ''
      this.$nextTick(() => {
        this.idAplic = ''
        this.idFase = ''
        this.idSolicitacao = ''
        this.dataInicioAcesso = ''
        this.dataFimAcesso = ''
      })
    }
  }
}

export default fccGetDadosMixin
